window.sq = window.sq || {}; window.sq.filterLogos = [
  {
    "id": "gid://shopify/Metaobject/85772009687",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/bitspower.png?v=1733294513",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Bitspower"
  },
  {
    "id": "gid://shopify/Metaobject/85767356631",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/primochill.png?v=1733289978",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Primochill"
  },
  {
    "id": "gid://shopify/Metaobject/85770141911",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/alphacool.png?v=1733293738",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Alphacool"
  },
  {
    "id": "gid://shopify/Metaobject/79163719895",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/EKWB2.jpg?v=1728445545",
    "altText": "EKWB",
    "width": 300,
    "height": 300,
    "value": "EK Waterblocks"
  },
  {
    "id": "gid://shopify/Metaobject/85776171223",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/monsoon.png?v=1733297098",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Monsoon"
  },
  {
    "id": "gid://shopify/Metaobject/85783642327",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/moddiy.png?v=1733300337",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "ModDIY"
  },
  {
    "id": "gid://shopify/Metaobject/85653389527",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/barrow.png?v=1733208256",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Barrow"
  },
  {
    "id": "gid://shopify/Metaobject/85773320407",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/phobya.png?v=1733295475",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Phobya"
  },
  {
    "id": "gid://shopify/Metaobject/85764309207",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/mod-smart.png?v=1733286863",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Mod/Smart"
  },
  {
    "id": "gid://shopify/Metaobject/85786886359",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/bykski.png?v=1733302979",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Bykski"
  },
  {
    "id": "gid://shopify/Metaobject/85764604119",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/thermaltake.png?v=1733287243",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Thermaltake"
  },
  {
    "id": "gid://shopify/Metaobject/79163850967",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/linkedin-square.png?v=1721234675",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "PPCS"
  },
  {
    "id": "gid://shopify/Metaobject/85768863959",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/koolance.png?v=1733291968",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Koolance"
  },
  {
    "id": "gid://shopify/Metaobject/85769978071",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/akasa.png?v=1733293660",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Akasa"
  },
  {
    "id": "gid://shopify/Metaobject/85764407511",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/modmytoys.png?v=1733287201",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "ModMyToys"
  },
  {
    "id": "gid://shopify/Metaobject/85766865111",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/silverstonetek.png?v=1733289188",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "SilverStone Technology"
  },
  {
    "id": "gid://shopify/Metaobject/85773648087",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/watercool.png?v=1733295754",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Watercool"
  },
  {
    "id": "gid://shopify/Metaobject/85764210903",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/lian-li.png?v=1733286719",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Lian-Li"
  },
  {
    "id": "gid://shopify/Metaobject/85653487831",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/cablemod.png?v=1733208296",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "CableMod"
  },
  {
    "id": "gid://shopify/Metaobject/85775089879",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/aquacomputer.png?v=1733296534",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Aquacomputer"
  },
  {
    "id": "gid://shopify/Metaobject/85767258327",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/ae.png?v=1733289705",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "AE"
  },
  {
    "id": "gid://shopify/Metaobject/85774532823",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/xspc.png?v=1733296074",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "XSPC"
  },
  {
    "id": "gid://shopify/Metaobject/85773779159",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/demciflex.png?v=1733295794",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "DEMCIflex"
  },
  {
    "id": "gid://shopify/Metaobject/85775122647",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/corsair.png?v=1733296612",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Corsair"
  },
  {
    "id": "gid://shopify/Metaobject/85785608407",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/singularity-computers.png?v=1733301752",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Singularity Computers"
  },
  {
    "id": "gid://shopify/Metaobject/85785936087",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/barrowch.png?v=1733302207",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Barrowch"
  },
  {
    "id": "gid://shopify/Metaobject/85766013143",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/swiftech.png?v=1733289065",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Swiftech"
  },
  {
    "id": "gid://shopify/Metaobject/85785051351",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/darkside.png?v=1733301071",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "DarkSide"
  },
  {
    "id": "gid://shopify/Metaobject/85787345111",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/mainframe-customs.png?v=1733303370",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "MAINFrame Customs"
  },
  {
    "id": "gid://shopify/Metaobject/85764866263",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/okgear.png?v=1733287789",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "OKGear"
  },
  {
    "id": "gid://shopify/Metaobject/85776203991",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/bitfenix.png?v=1733297133",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Bitfenix"
  },
  {
    "id": "gid://shopify/Metaobject/85765357783",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/coolermaster.png?v=1733288149",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Cooler Master"
  },
  {
    "id": "gid://shopify/Metaobject/85774663895",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/akust.png?v=1733296167",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Akust"
  },
  {
    "id": "gid://shopify/Metaobject/85767160023",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/lamptron.png?v=1733289589",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Lamptron"
  },
  {
    "id": "gid://shopify/Metaobject/85767979223",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/hardware-labs.png?v=1733290140",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Hardware Labs"
  },
  {
    "id": "gid://shopify/Metaobject/85891186903",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/enzotech.png?v=1733372766",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Enzotech"
  },
  {
    "id": "gid://shopify/Metaobject/85765456087",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/evercool.png?v=1733288243",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Evercool"
  },
  {
    "id": "gid://shopify/Metaobject/85785477335",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/phanteks.png?v=1733301545",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Phanteks"
  },
  {
    "id": "gid://shopify/Metaobject/85764833495",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/logisys.png?v=1733287670",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Logisys"
  },
  {
    "id": "gid://shopify/Metaobject/85776302295",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/mayhems.png?v=1733297206",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Mayhems"
  },
  {
    "id": "gid://shopify/Metaobject/85772697815",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/mnpctech_063068da-d05b-4119-b6bd-33dfbafb1d18.png?v=1733294807",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "MNPCtech"
  },
  {
    "id": "gid://shopify/Metaobject/85768339671",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/ACRYAN.png?v=1733290924",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "AC Ryan"
  },
  {
    "id": "gid://shopify/Metaobject/85784789207",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/frozenq.png?v=1733300491",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "FrozenQ"
  },
  {
    "id": "gid://shopify/Metaobject/85785182423",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/thermal-grizzly.png?v=1733301306",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Thermal Grizzly"
  },
  {
    "id": "gid://shopify/Metaobject/85776728279",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/fractaldesign.png?v=1733297402",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Fractal Design"
  },
  {
    "id": "gid://shopify/Metaobject/85776695511",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/e22.png?v=1733297362",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "E22"
  },
  {
    "id": "gid://shopify/Metaobject/85775024343",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/evga.png?v=1733296491",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "EVGA"
  },
  {
    "id": "gid://shopify/Metaobject/85773418711",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/nzxt.png?v=1733295556",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "NZXT"
  },
  {
    "id": "gid://shopify/Metaobject/85776236759",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/syba.png?v=1733297163",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "SYBA"
  },
  {
    "id": "gid://shopify/Metaobject/85769158871",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/corepad.png?v=1733292134",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Corepad"
  },
  {
    "id": "gid://shopify/Metaobject/85769781463",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/scythe.png?v=1733293325",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Scythe"
  },
  {
    "id": "gid://shopify/Metaobject/85772599511",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/noctua.png?v=1733294778",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Noctua"
  },
  {
    "id": "gid://shopify/Metaobject/85774958807",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/mod-right.png?v=1733296436",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Modright"
  },
  {
    "id": "gid://shopify/Metaobject/85788491991",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/raijintek.png?v=1733304210",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Raijintek"
  },
  {
    "id": "gid://shopify/Metaobject/85773549783",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/gelid-solutions.png?v=1733295618",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Gelid Solutions"
  },
  {
    "id": "gid://shopify/Metaobject/85765849303",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/techn.png?v=1733288635",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Techflex"
  },
  {
    "id": "gid://shopify/Metaobject/85772796119",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/asus.png?v=1733295037",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "ASUS"
  },
  {
    "id": "gid://shopify/Metaobject/85771911383",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/noiseblocker.png?v=1733294323",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Blacknoise"
  },
  {
    "id": "gid://shopify/Metaobject/85765030103",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/vantec.png?v=1733287974",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Vantec"
  },
  {
    "id": "gid://shopify/Metaobject/85786558679",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/icy-diock.png?v=1733302618",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "IcyDock"
  },
  {
    "id": "gid://shopify/Metaobject/85772533975",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/silenx.png?v=1733294689",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "SilenX"
  },
  {
    "id": "gid://shopify/Metaobject/85767291095",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/aerocool.png?v=1733289772",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Aerocool"
  },
  {
    "id": "gid://shopify/Metaobject/85787050199",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/optimus.png?v=1733303238",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Optimus"
  },
  {
    "id": "gid://shopify/Metaobject/85776662743",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/cougar.png?v=1733297316",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Cougar"
  },
  {
    "id": "gid://shopify/Metaobject/85766897879",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/matrix-orbital.png?v=1733289332",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Matrix Orbital"
  },
  {
    "id": "gid://shopify/Metaobject/85768929495",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/titan.png?v=1733292011",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Titan"
  },
  {
    "id": "gid://shopify/Metaobject/85771976919",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/cooljag.png?v=1733294447",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "CoolJag"
  },
  {
    "id": "gid://shopify/Metaobject/85784887511",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/bequiet.png?v=1733300767",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Be Quiet"
  },
  {
    "id": "gid://shopify/Metaobject/85767225559",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/delta-electronics.png?v=1733289653",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Delta Electronics"
  },
  {
    "id": "gid://shopify/Metaobject/85772566743",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/kingwin.png?v=1733294752",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Kingwin"
  },
  {
    "id": "gid://shopify/Metaobject/85765128407",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/enermax.png?v=1733288020",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Enermax"
  },
  {
    "id": "gid://shopify/Metaobject/85768175831",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/widget-supply.png?v=1733290843",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Widget Supply"
  },
  {
    "id": "gid://shopify/Metaobject/85773353175",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/inwin.png?v=1733295526",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "INWIN"
  },
  {
    "id": "gid://shopify/Metaobject/85773517015",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/xigmatek.png?v=1733295581",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Xigmatek"
  },
  {
    "id": "gid://shopify/Metaobject/85786656983",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/maxfinder.png?v=1733302748",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Maxfinder"
  },
  {
    "id": "gid://shopify/Metaobject/85785542871",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/kingpin-cooling.png?v=1733301646",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "KingPin Cooling"
  },
  {
    "id": "gid://shopify/Metaobject/85765980375",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/bytecc.png?v=1733288992",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Bytecc USA"
  },
  {
    "id": "gid://shopify/Metaobject/85774434519",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/dynatron.png?v=1733296013",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Dynatron"
  },
  {
    "id": "gid://shopify/Metaobject/85786591447",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/steelseries.png?v=1733302662",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Steelseries"
  },
  {
    "id": "gid://shopify/Metaobject/85787967703",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/msi.png?v=1733303689",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "MSI"
  },
  {
    "id": "gid://shopify/Metaobject/85768405207",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/startech.png?v=1733291154",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Startech"
  },
  {
    "id": "gid://shopify/Metaobject/85774500055",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/aquatuning.png?v=1733296046",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Aquatuning"
  },
  {
    "id": "gid://shopify/Metaobject/85788557527",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/modultra.png?v=1733304296",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Modultra"
  },
  {
    "id": "gid://shopify/Metaobject/85653520599",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/stealkey-customs.png?v=1733208375",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Stealkey Customs"
  },
  {
    "id": "gid://shopify/Metaobject/85765226711",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/antec.png?v=1733288070",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Antec"
  },
  {
    "id": "gid://shopify/Metaobject/85786919127",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/sunbeamtek.png?v=1733303009",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Sunbeamtech"
  },
  {
    "id": "gid://shopify/Metaobject/85776367831",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/reeven.png?v=1733297240",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Reeven"
  },
  {
    "id": "gid://shopify/Metaobject/85786198231",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/mitron.png?v=1733302295",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Mitron"
  },
  {
    "id": "gid://shopify/Metaobject/85764931799",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/sunon.png?v=1733287869",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Sunon"
  },
  {
    "id": "gid://shopify/Metaobject/85767454935",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/manhattan.png?v=1733290089",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Manhattan"
  },
  {
    "id": "gid://shopify/Metaobject/85769879767",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/magicool.png?v=1733293564",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Magicool"
  },
  {
    "id": "gid://shopify/Metaobject/85772468439",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/creative-labs.png?v=1733294652",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Creative"
  },
  {
    "id": "gid://shopify/Metaobject/85774696663",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/prolimatech.png?v=1733296201",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Prolimatech"
  },
  {
    "id": "gid://shopify/Metaobject/85769224407",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/logitech.png?v=1733292199",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Logitech"
  },
  {
    "id": "gid://shopify/Metaobject/85788426455",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/ifixit_eb2649e7-2f2f-4d61-9c13-794d6b826186.png?v=1733304093",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "IFixIt"
  },
  {
    "id": "gid://shopify/Metaobject/85787410647",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/liquid-cool.png?v=1733303533",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Liquid.Cool"
  },
  {
    "id": "gid://shopify/Metaobject/85787836631",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/techn_74d28f5e-8bf5-410a-b973-bcfc11023896.png?v=1733303624",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "TechN"
  },
  {
    "id": "gid://shopify/Metaobject/85788655831",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/flexegraph.png?v=1733304375",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Flexegraph"
  },
  {
    "id": "gid://shopify/Metaobject/85768077527",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/arctic.png?v=1733290726",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Arctic"
  },
  {
    "id": "gid://shopify/Metaobject/85768110295",
    "url": "https://cdn.shopify.com/s/files/1/0705/9688/6743/files/dremel.png?v=1733290770",
    "altText": "",
    "width": 300,
    "height": 300,
    "value": "Dremel"
  }
];